import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeLeaveRequest  {
    _originalTypeClassName = "zERP.BO.EmployeeLeaveRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeLeaveRequest.translate = translateService;
}
this.FileData = [];
this.Actions = [];
this.Id = null;
this.DateRequested = null;
this.DateFrom = null;
this.DateTo = null;
this.WorkingHours = null;
this.WorkingDays = null;
this.InsuredDays = null;
this.Status = null;
this.EmployeeNotes = null;
this.HRNotes = null;
this.FlowStepIndex = 0;
this.DateApproved = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateRequested:any;
DateFrom:any;
DateTo:any;
WorkingHours:any;
WorkingDays:any;
InsuredDays:any;
Status:any;
EmployeeNotes:any;
HRNotes:any;
FlowStepIndex:any;
DateApproved:any;
RequestedBy:any;
EmployeeLeave:any;
Assignee:any;
ActiveTask:any;
FileData:any;
LeaveRule:any;
ApprovalFlowScenario:any;
Actions:any;
ApprovedBy:any;
static setRequestedBy = ($this, value) => {
var oldValue = $this.RequestedBy;
$this.RequestedBy = value;
if (value != null) {
}
}
static setEmployeeLeave = ($this, value) => {
var oldValue = $this.EmployeeLeave;
$this.EmployeeLeave = value;
if (value != null) {
}
}
static setAssignee = ($this, value) => {
var oldValue = $this.Assignee;
$this.Assignee = value;
if (value != null) {
}
}
static setActiveTask = ($this, value) => {
var oldValue = $this.ActiveTask;
$this.ActiveTask = value;
if (value != null) {
}
}
static setFileData = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileData == null) $this.FileData = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileData.length > 0) {
                    Domain.EmployeeLeaveRequest.removeFileData($this, $this.FileData[0]);
                }

                Domain.EmployeeLeaveRequest.addManyFileData($this, copyItems);
            }
static addManyFileData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeLeaveRequest.addFileData($this, items[i]);
                }
            }
static addFileData = ($this, item) => {
                if ($this.FileData == null) $this.FileData = [];
                if (item == null || $this.FileData.indexOf(item) > -1) return;
                $this.FileData.push(item);
}
static addRangeFileData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeLeaveRequest.addFileData($this, item));
            }
static removeFileData = ($this, item) => {
                if ($this == null || $this.FileData == null || $this.FileData.indexOf(item) === -1) return;
                var _index = $this.FileData.indexOf(item);
                $this.FileData.splice(_index, 1);
}
static clearFileData = ($this) => { $this.FileData = null; }
static setLeaveRule = ($this, value) => {
var oldValue = $this.LeaveRule;
$this.LeaveRule = value;
if (value != null) {
}
}
static setApprovalFlowScenario = ($this, value) => {
var oldValue = $this.ApprovalFlowScenario;
$this.ApprovalFlowScenario = value;
if (value != null) {
}
}
static setActions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Actions == null) $this.Actions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Actions.length > 0) {
                    Domain.EmployeeLeaveRequest.removeActions($this, $this.Actions[0]);
                }

                Domain.EmployeeLeaveRequest.addManyActions($this, copyItems);
            }
static addManyActions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeLeaveRequest.addActions($this, items[i]);
                }
            }
static addActions = ($this, item) => {
                if ($this.Actions == null) $this.Actions = [];
                if (item == null || $this.Actions.indexOf(item) > -1) return;
                $this.Actions.push(item);
if (item.LeaveRequest != $this) {
Domain.LeaveRequestAction.setLeaveRequest(item, $this);
}
}
static addRangeActions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeLeaveRequest.addActions($this, item));
            }
static removeActions = ($this, item) => {
                if ($this == null || $this.Actions == null || $this.Actions.indexOf(item) === -1) return;
                var _index = $this.Actions.indexOf(item);
                $this.Actions.splice(_index, 1);
item.LeaveRequest = null;
}
static clearActions = ($this) => { $this.Actions = null; }
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}

static CanBeDeleted($this: any): any{if ($this?.Status == Domain.LeaveRequestStatus.Temporary) {return true;}
if ($this?.Status == Domain.LeaveRequestStatus.Approved && (new Date(new Date(new Date($this?.DateFrom)?.setHours(0, 0, 0, 0))).getTime()) > (new Date(new Date(new Date(moment().toDate())?.setHours(0, 0, 0, 0))).getTime()) && window._context.currentUserPermissions.indexOf("CanDeleteLeaves") > -1) {return true;}
return false;
}
static Check($this: any): any{}
static CheckStatusTransition($this: any, newStatus: any): any{let user = Domain.UserAccount.GetActive();
let isHr = Domain.ApplicationUser.IsInRole(user, "HRUser");
if (newStatus == Domain.LeaveRequestStatus.Temporary) {return $this?.Status == Domain.LeaveRequestStatus.Temporary;}else if (newStatus == Domain.LeaveRequestStatus.Pending) {return $this?.Status == Domain.LeaveRequestStatus.Temporary;}else if (newStatus == Domain.LeaveRequestStatus.Cancelled) {return ($this?.Status != Domain.LeaveRequestStatus.Rejected && $this?.Status != Domain.LeaveRequestStatus.Cancelled) && (isHr || $this?.Assignee?.UserName == user?.UserName || $this?.RequestedBy == user);}else if (newStatus == Domain.LeaveRequestStatus.Approved) {return $this?.Status == Domain.LeaveRequestStatus.Pending && (isHr || $this?.Assignee?.UserName == user?.UserName);}else if (newStatus == Domain.LeaveRequestStatus.Rejected) {return $this?.Status == Domain.LeaveRequestStatus.Pending && (isHr || $this?.Assignee?.UserName == user?.UserName);}
return false;
}
static FillApprovalScenarion($this: any): any{if ($this?.ApprovalFlowScenario != null) {return;}
Domain.EmployeeLeaveRequest.setApprovalFlowScenario($this, Domain.ApprovalFlow.GetScenario($this?.LeaveRule?.ApprovalFlow, $this?.EmployeeLeave?.EmployeeContract));
}
static GetEmployeeContract(year: any,employeeLeave: any): any{let contract = new Domain.EmployeeContract();
console.warn(employeeLeave?.Year);
return contract;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}